import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/newControl.svg'
import _imports_1 from '@/assets/controlClone.svg'
import _imports_2 from '@/assets/filter.svg'
import _imports_3 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 overflow-x-hidden" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mt-5 bg-white border border-lightgrey" }
const _hoisted_4 = { class: "w-full p-5 pb-0" }
const _hoisted_5 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_6 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_7 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_8 = { class: "text-xs flex flex-wrap" }
const _hoisted_9 = { class: "row flex justify-between items-center mx-5" }
const _hoisted_10 = { class: "buttonposition flex justify-end items-center gap-3" }
const _hoisted_11 = {
  ref: "menuContainer",
  class: "flex flex-row-reverse"
}
const _hoisted_12 = {
  key: 0,
  class: "card shadow-sm z-50 absolute cursor-pointer marginTop"
}
const _hoisted_13 = { class: "row rounded flex text-xs pt-2" }
const _hoisted_14 = { class: "w-2/5" }
const _hoisted_15 = { class: "mt-3 border border-lightgrey option rounded overflow-y-auto" }
const _hoisted_16 = { class: "overflow-y-auto mx-1 pt-1" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-xs" }
const _hoisted_19 = { class: "w-3/5" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "w-full pt-0" }
const _hoisted_22 = {
  class: "mt-3 border flex-col text-sm border-lightgrey option overflow-y-auto ml-1 rounded",
  ref: "control"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_25 = ["value", "id", "onChange"]
const _hoisted_26 = ["for"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_30 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_31 = { class: "row flex justify-between items-center" }
const _hoisted_32 = { class: "mx-5 pb-5" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "buttonposition flex justify-end items-center px-5 mx-5" }
const _hoisted_35 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_36 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_37 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "flex flex-col h-full" }
const _hoisted_41 = { class: "flex-1 overflow-auto" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_44 = { class: "formcontainer flex flex-col" }
const _hoisted_45 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_46 = { class: "w-full mt-3" }
const _hoisted_47 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_48 = {
  key: 0,
  class: "error-text"
}
const _hoisted_49 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_50 = { class: "flex flex-row w-full" }
const _hoisted_51 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_52 = {
  key: 0,
  class: "error-text"
}
const _hoisted_53 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_54 = {
  key: 0,
  class: "error-text"
}
const _hoisted_55 = { class: "flex w-full" }
const _hoisted_56 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_57 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_58 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_59 = { class: "formcontainer flex flex-col" }
const _hoisted_60 = { class: "row flex flex-row w-full" }
const _hoisted_61 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_64 = { key: 1 }
const _hoisted_65 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_66 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_67 = { class: "w-full" }
const _hoisted_68 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_69 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_70 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_71 = { class: "w-full" }
const _hoisted_72 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_73 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_74 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_75 = { class: "w-full" }
const _hoisted_76 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_77 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_78 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_79 = { class: "w-full" }
const _hoisted_80 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_81 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_82 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_83 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_84 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_88 = ["disabled"]
const _hoisted_89 = ["disabled"]
const _hoisted_90 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_91 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_92 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "flex flex-col h-full" }
const _hoisted_96 = { class: "flex-1 overflow-auto" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_99 = { class: "formcontainer flex flex-col" }
const _hoisted_100 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_101 = { class: "w-full mt-3" }
const _hoisted_102 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_103 = {
  key: 0,
  class: "error-text"
}
const _hoisted_104 = { class: "flex flex-row w-full" }
const _hoisted_105 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_106 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_107 = {
  key: 0,
  class: "error-text"
}
const _hoisted_108 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_109 = { key: 1 }
const _hoisted_110 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_111 = {
  key: 0,
  class: "error-text"
}
const _hoisted_112 = { class: "flex flex-row w-full" }
const _hoisted_113 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_114 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_115 = { key: 1 }
const _hoisted_116 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_117 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_118 = { class: "formcontainer flex flex-col" }
const _hoisted_119 = { class: "row flex flex-row w-full" }
const _hoisted_120 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_121 = { key: 1 }
const _hoisted_122 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_123 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_124 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_125 = { key: 1 }
const _hoisted_126 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_127 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_128 = { class: "w-full" }
const _hoisted_129 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_130 = ["disabled"]
const _hoisted_131 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_132 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_133 = { class: "w-full" }
const _hoisted_134 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_135 = ["disabled"]
const _hoisted_136 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_137 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_138 = { class: "w-full" }
const _hoisted_139 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_140 = ["disabled"]
const _hoisted_141 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_142 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_143 = { class: "w-full" }
const _hoisted_144 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_145 = ["disabled"]
const _hoisted_146 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_147 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_148 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_149 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_150 = { key: 1 }
const _hoisted_151 = { key: 0 }
const _hoisted_152 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_153 = ["disabled"]
const _hoisted_154 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "row flex justify-between w-full" }, [
        _createElementVNode("h1", { class: "title" }, "Risk - Mitigate")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.systemHead)
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, "Systems"))
            : _createCommentVNode("", true),
          (_ctx.processHead)
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, "Process"))
            : _createCommentVNode("", true),
          (_ctx.organizationHead)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, "Organization"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemsSelected, (obj, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "mr-2 mb-2 bg-primary text-white px-2 py-1 rounded"
              }, _toDisplayString(obj.label), 1))
            }), 128))
          ])
        ]),
        _cache[63] || (_cache[63] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5 mt-3 mb-2" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "text-base font-semibold" }, "Mapping of Controls to Mitigate", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                class: _normalizeClass(["btns flex justify-center items-center", _ctx.isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'])
              }, "Add Control", 2),
              (_ctx.isMenuVisible)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                    _createElementVNode("li", {
                      class: "px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.customPopupPopup && _ctx.customPopupPopup(...args)))
                    }, _cache[53] || (_cache[53] = [
                      _createElementVNode("div", { class: "flex" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "",
                          class: "mr-2"
                        }),
                        _createTextVNode("New Control")
                      ], -1)
                    ])),
                    _createElementVNode("li", {
                      class: "px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.customClonePopup && _ctx.customClonePopup(...args)))
                    }, _cache[54] || (_cache[54] = [
                      _createElementVNode("div", { class: "flex" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "",
                          class: "mr-2"
                        }),
                        _createTextVNode(" Clone Control")
                      ], -1)
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ], 512),
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.sameControls ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addToTable && _ctx.addToTable(...args)))
            }, "Add", 2)
          ])
        ]),
        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5 mt-2 mb-2" }, null, -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col px-5", { 'pb-5': _ctx.sortedData.length == 0 }])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "flex",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('framework')))
              }, [
                _cache[56] || (_cache[56] = _createElementVNode("h2", { class: "header cursor-pointer" }, "Framework", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'framework' ? _ctx.classSort : 'opacity-50'])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[57] || (_cache[57] = _createElementVNode("div", { class: "p-2" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "inputboxstyling",
                    placeholder: "Search Frameworks"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsData, (framework, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "rounded",
                      ref_for: true,
                      ref: "framework"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["p-3 mt-1 pl-5 cursor-pointer rounded", [framework == _ctx.systemIndex ? 'bg-primary text-white font-bold' : 'bg-white hover:bg-lightgrey',index==0?'rounded-t':'']]),
                        onClick: ($event: any) => (_ctx.systemIndex = framework)
                      }, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(framework), 1)
                      ], 10, _hoisted_17)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "flex",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort('controls')))
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[58] || (_cache[58] = _createElementVNode("h2", { class: "header cursor-pointer" }, "Controls", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'controls' ? _ctx.classSort : 'opacity-50'])
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[59] || (_cache[59] = _createElementVNode("div", { class: "p-2" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "inputboxstyling",
                      placeholder: "Search Controls"
                    })
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedControlData, (control, key, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "mt-2"
                    }, [
                      (key == _ctx.systemIndex)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(control, (ctrl) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "h-7 flex justify-normal items-center cursor-pointer pl-5 hover:bg-lightgrey",
                                key: ctrl._id
                              }, [
                                _createElementVNode("div", _hoisted_24, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedChild) = $event)),
                                    value: ctrl._id,
                                    id: ctrl._id,
                                    type: "checkbox",
                                    class: "checkbox",
                                    onChange: ($event: any) => (_ctx.chooseControls(ctrl._id)),
                                    ref_for: true,
                                    ref: "child"
                                  }, null, 40, _hoisted_25), [
                                    [_vModelCheckbox, _ctx.checkedChild]
                                  ]),
                                  _createElementVNode("label", {
                                    for: ctrl._id,
                                    class: "pl-3 cursor-pointer"
                                  }, _toDisplayString(ctrl.controlTitle), 9, _hoisted_26)
                                ]),
                                _createElementVNode("div", {
                                  class: "h-7 w-full",
                                  onClick: ($event: any) => (_ctx.childSelect(ctrl._id))
                                }, null, 8, _hoisted_27)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 512),
                (_ctx.v$.checkedChild.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_ctx.v$.checkedChild.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 2),
        (_ctx.tableRow.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _cache[62] || (_cache[62] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5 mt-3 mb-2" }, null, -1)),
              _createElementVNode("div", _hoisted_31, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "mx-5 text-base font-semibold" }, "Selected Controls", -1)),
                _createElementVNode("button", {
                  class: "mr-5 filterButton flex",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterOpen('table')))
                }, _cache[60] || (_cache[60] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "filterIcon"
                  }, null, -1),
                  _createTextVNode(" Filters ")
                ]))
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_newTable, {
                  tableRowData: _ctx.tableRow,
                  headersData: _ctx.headers
                }, null, 8, ["tableRowData", "headersData"]),
                (_ctx.toolTipActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.tableRow.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["fixed bottom-7 bg-white h-16 flex justify-end items-center", { 'w-40': _ctx.isSidebarToggle, 'w-10': !_ctx.isSidebarToggle }])
        }, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: _normalizeClass(["btnprimary mr-1.5", _ctx.existedControls ? 'btnprimary' : 'btndisabled pointer-events-none']),
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.rollBack && _ctx.rollBack(...args)))
            }, "Reset", 2),
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.existedControls ? 'btnprimary' : 'btndisabled pointer-events-none'),
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveSystemsControls && _ctx.saveSystemsControls(...args)))
            }, "Next", 2)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.customPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.customPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              (_ctx.customControlObject != undefined && _ctx.customControlObject.classificationType == 3 )
                ? (_openBlock(), _createElementBlock("h1", _hoisted_36, _toDisplayString(_ctx.customControlObject.controlTitle), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_ctx.addpopup==false)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_38, _toDisplayString(_ctx.customControlObject.controlTitle || 'N/A'), 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_39, "Control"))
                  ])),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
              }, _cache[66] || (_cache[66] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("fieldset", {
                  disabled: _ctx.customControlObject._id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        (_ctx.addpopup==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _cache[67] || (_cache[67] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': _ctx.v$.customControlObject.controlTitle.$error
                                                }]),
                                  placeholder: "Title",
                                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.customControlObject.controlTitle.$touch())),
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customControlObject.controlTitle) = $event))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlTitle,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.customControlObject.controlTitle.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      (_ctx.v$.customControlObject.controlTitle.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Required"))
                                        : (_ctx.v$.customControlObject.controlTitle && _ctx.v$.customControlObject.controlTitle.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[68] || (_cache[68] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frequency", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.customControlObject.controlFrequency,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customControlObject.controlFrequency) = $event)),
                              options: _ctx.dbFrequency,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                    'is-invalid': _ctx.v$.customControlObject.controlFrequency.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlFrequency === '',
                                                }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.customControlObject.controlFrequency.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                  (_ctx.v$.customControlObject.controlFrequency.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[69] || (_cache[69] = _createElementVNode("label", { class: "controllabel text-xs" }, "Priority", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.customControlObject.controlPriority,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customControlObject.controlPriority) = $event)),
                              options: _ctx.dbPriority,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                    'is-invalid': _ctx.v$.customControlObject.controlPriority.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlPriority === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlPriority !== ''
                                                }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.customControlObject.controlPriority.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  (_ctx.v$.customControlObject.controlPriority.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[70] || (_cache[70] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.customControlObject.clientUniqueId ? _ctx.customControlObject.clientUniqueId:_ctx.customControlObject.controlNumber|| 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "text",
                                  class: "inputboxstyling mt-2 disiableState",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customControlObject.controlNumber) = $event)),
                                  onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.customControlObject.controlNumber.$touch())),
                                  placeholder: "Number",
                                  disabled: ""
                                }, null, 544)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlNumber,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[71] || (_cache[71] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.customControlObject.controlType,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.customControlObject.controlType) = $event)),
                              suggestions: _ctx.filteredControlTypeOptions,
                              onComplete: _ctx.asyncFindControlType,
                              field: "label",
                              forceSelection: true,
                              placeholder: "Category",
                              class: "p-inputtext-sm systemsstyling w-full"
                            }, null, 8, ["modelValue", "suggestions", "onComplete"]),
                            (_ctx.v$.customControlObject.controlType.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                  (_ctx.v$.customControlObject.controlType && _ctx.v$.customControlObject.controlType.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[72] || (_cache[72] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.customControlObject.controlFamily || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customControlObject.controlFamily,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customControlObject.controlFamily) = $event)),
                                      suggestions: _ctx.filteredControlFamilyOptions,
                                      onComplete: _ctx.asyncFindControlFamily,
                                      field: "label",
                                      forceSelection: true,
                                      placeholder: "Control Family",
                                      class: "p-inputtext-sm systemsstyling w-full"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                  ]))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-3/6 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[73] || (_cache[73] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.customControlObject.controlClass || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customControlObject.controlClass,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.customControlObject.controlClass) = $event)),
                                      suggestions: _ctx.filteredControlClassOptions,
                                      onComplete: _ctx.asyncFindControlClass,
                                      field: "label",
                                      forceSelection: true,
                                      placeholder: "Control Class",
                                      class: "p-inputtext-sm systemsstyling w-full"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                  ])),
                              (_ctx.v$.customControlObject.controlClass.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    (_ctx.v$.customControlObject.controlClass && _ctx.v$.customControlObject.controlClass.restrictCharacters300.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_67, [
                            _cache[74] || (_cache[74] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_ctx.customControlObject.Description || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                                        'is-invalid': _ctx.v$.customControlObject.Description.$error
                                                    }]),
                                  placeholder: "Description",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.customControlObject.Description) = $event)),
                                  onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.customControlObject.Description.$touch()))
                                }, "                                                ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.Description.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                  (_ctx.v$.customControlObject.Description && _ctx.v$.customControlObject.Description.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_71, [
                            _cache[75] || (_cache[75] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.customControlObject.controlMaintenanceTask || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                                        'is-invalid': _ctx.v$.customControlObject.controlMaintenanceTask.$error
                                                    }]),
                                  placeholder: "Tasks",
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.customControlObject.controlMaintenanceTask) = $event)),
                                  onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.v$.customControlObject.controlMaintenanceTask.$touch()))
                                }, "                                                ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlMaintenanceTask,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlMaintenanceTask.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                  (_ctx.v$.customControlObject.controlMaintenanceTask && _ctx.v$.customControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_75, [
                            _cache[76] || (_cache[76] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.customControlObject.controlPolicies || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                                        'is-invalid': _ctx.v$.customControlObject.controlPolicies.$error
                                                    }]),
                                  placeholder: "Policies",
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.customControlObject.controlPolicies) = $event)),
                                  onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.customControlObject.controlPolicies.$touch()))
                                }, "                                                ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlPolicies,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlPolicies.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  (_ctx.v$.customControlObject.controlPolicies && _ctx.v$.customControlObject.controlPolicies.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_79, [
                            _cache[77] || (_cache[77] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.customControlObject.controlGuidance || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                                        'is-invalid': _ctx.v$.customControlObject.controlGuidance.$error
                                                    }]),
                                  placeholder: "Guidance",
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.customControlObject.controlGuidance) = $event)),
                                  onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.v$.customControlObject.controlGuidance.$touch()))
                                }, "                                                ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlGuidance,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlGuidance.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                  (_ctx.v$.customControlObject.controlGuidance && _ctx.v$.customControlObject.controlGuidance.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[78] || (_cache[78] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(_ctx.customControlObject.controlOptionFrameWork || 'N/A'), 1))
                            : (_openBlock(), _createBlock(_component_Select, {
                                key: 1,
                                modelValue: _ctx.customControlObject.controlOptionFrameWork,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.customControlObject.controlOptionFrameWork) = $event)),
                                options: _ctx.frameWorksList,
                                onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.getFrameworkControls(_ctx.customControlObject.controlOptionFrameWork))),
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                    'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork !== ''
                                                }])
                              }, null, 8, ["modelValue", "options", "class"]))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_ctx.customControlObject.frameworkControls || 'N/A'), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.customControlObject.frameworkControls,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.customControlObject.frameworkControls) = $event)),
                                  options: _ctx.frameworkControls,
                                  optionValue: "value",
                                  optionLabel: "label",
                                  disabled: _ctx.customControlObject.controlOptionFrameWork=='',
                                  appendTo: "self",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                                    'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork === '',
                                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork !== ''
                                                                }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])
                              ]))
                        ], 2)
                      ])
                    ])
                  ])
                ], 8, _hoisted_42)
              ]),
              (_ctx.customPopup=true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                    _cache[80] || (_cache[80] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    (!_ctx.customControlObject._id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onCancelbtnCustom('cancel')))
                          }, "Reset", 10, _hoisted_88),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.saveCustomControl(_ctx.customControlObject)))
                          }, "Save", 10, _hoisted_89)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.clonePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.clonePopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_90, [
              (_ctx.customCloneControlObject != undefined && _ctx.customCloneControlObject.classificationType == 3 )
                ? (_openBlock(), _createElementBlock("h1", _hoisted_91, _toDisplayString(_ctx.customCloneControlObject.controlTitle), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    (_ctx.addpopup==false)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_93, _toDisplayString(_ctx.customCloneControlObject.controlTitle || 'N/A'), 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_94, "Clone Control"))
                  ])),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
              }, _cache[81] || (_cache[81] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("fieldset", {
                  disabled: _ctx.customCloneControlObject._id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        (_ctx.addpopup==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _cache[82] || (_cache[82] = _createElementVNode("label", { class: "controllabel" }, "Control Title", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.customCloneControlObject.controlTitle,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.customCloneControlObject.controlTitle) = $event)),
                                  suggestions: _ctx.filteredICOptions,
                                  onComplete: _ctx.asyncFindInternalControls,
                                  onItemSelect: _ctx.bindOtherFields,
                                  onClear: _ctx.resetCloneControlFields,
                                  onInput: _ctx.checkTitleCleared,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  field: "label",
                                  panelClass: "clone-popup-panel",
                                  forceSelection: true,
                                  placeholder: "Control Title",
                                  class: _normalizeClass(["p-inputtext-sm custom-multiselect systemsstyling w-full", { 'p-invalid': _ctx.v$.customCloneControlObject.controlTitle.$error }])
                                }, null, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "onClear", "onInput", "class"]),
                                (_ctx.v$.customCloneControlObject.controlTitle.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                      (_ctx.v$.customCloneControlObject.controlTitle.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_104, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[83] || (_cache[83] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frequency", -1)),
                            (_ctx.addpopup==false && (_ctx.selectedTabIndex!=1|| _ctx.selectedTabIndex==1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.dbFrequency.find((item) => item.value === _ctx.customCloneControlObject.controlFrequency)?.key ?? 'N/A'), 1))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customCloneControlObject.controlFrequency,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.customCloneControlObject.controlFrequency) = $event)),
                                  options: _ctx.dbFrequency,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  disabled: !_ctx.customCloneControlObject.controlTitle,
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.customCloneControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlFrequency === '',
                                    }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])),
                            (_ctx.v$.customCloneControlObject.controlFrequency.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                  (_ctx.v$.customCloneControlObject.controlFrequency.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[84] || (_cache[84] = _createElementVNode("label", { class: "controllabel text-xs" }, "Priority", -1)),
                            (_ctx.addpopup==false && (_ctx.selectedTabIndex!=1|| _ctx.selectedTabIndex==1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  (_ctx.customCloneControlObject.controlPriority && typeof _ctx.customCloneControlObject.controlPriority === 'number')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.customCloneControlObject.controlPriority)])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.customCloneControlObject.controlPriority)])
                                        }, _toDisplayString(_ctx.getProirityLabel(_ctx.customCloneControlObject.controlPriority)), 3)
                                      ], 2))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_109, "N/A"))
                                ]))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customCloneControlObject.controlPriority,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.customCloneControlObject.controlPriority) = $event)),
                                  options: _ctx.dbPriority,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  disabled: !_ctx.customCloneControlObject.controlTitle,
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.customCloneControlObject.controlPriority.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlPriority === '',
                                    }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])),
                            (_ctx.v$.customCloneControlObject.controlPriority.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                  (_ctx.v$.customCloneControlObject.controlPriority.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[85] || (_cache[85] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.customCloneControlObject.clientUniqueId ? _ctx.customCloneControlObject.clientUniqueId:_ctx.customCloneControlObject.controlNumber|| 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "text",
                                  class: "inputboxstyling mt-2 disiableState",
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.customCloneControlObject.controlNumber) = $event)),
                                  placeholder: "Number",
                                  disabled: ""
                                }, null, 512)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlNumber,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", null, [
                              _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                              _createElementVNode("div", null, [
                                (_ctx.addpopup==false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.customCloneControlObject.controlType || 'N/A'), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                      _createVNode(_component_AutoComplete, {
                                        modelValue: _ctx.customCloneControlObject.controlType,
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.customCloneControlObject.controlType) = $event)),
                                        suggestions: _ctx.filteredControlTypeOptions,
                                        onComplete: _ctx.asyncFindControlType,
                                        field: "label",
                                        forceSelection: true,
                                        placeholder: "Category",
                                        disabled: !_ctx.customCloneControlObject.controlTitle,
                                        class: "p-inputtext-sm systemsstyling w-full"
                                      }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                    ])),
                                (_ctx.v$.customCloneControlObject.controlType.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                      (_ctx.v$.customCloneControlObject.controlType && _ctx.v$.customCloneControlObject.controlType.restrictCharacters300.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[87] || (_cache[87] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_ctx.customCloneControlObject.controlFamily || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customCloneControlObject.controlFamily,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.customCloneControlObject.controlFamily) = $event)),
                                      suggestions: _ctx.filteredControlFamilyOptions,
                                      onComplete: _ctx.asyncFindControlFamily,
                                      field: "label",
                                      forceSelection: true,
                                      disabled: !_ctx.customCloneControlObject.controlTitle,
                                      placeholder: "Control Family",
                                      class: _normalizeClass(["p-inputtext-sm systemsstyling w-full", { 'p-invalid': _ctx.v$.customCloneControlObject.controlFamily.$error }])
                                    }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"]),
                                    (_ctx.v$.customCloneControlObject.controlFamily.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                          (_ctx.v$.customCloneControlObject.controlFamily && _ctx.v$.customCloneControlObject.controlFamily.restrictCharacters30.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_123, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-3/6 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[88] || (_cache[88] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(_ctx.customCloneControlObject.controlClass || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customCloneControlObject.controlClass,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.customCloneControlObject.controlClass) = $event)),
                                      suggestions: _ctx.filteredControlClassOptions,
                                      onComplete: _ctx.asyncFindControlClass,
                                      field: "label",
                                      disabled: !_ctx.customCloneControlObject.controlTitle,
                                      forceSelection: true,
                                      placeholder: "Control Class",
                                      class: "p-inputtext-sm systemsstyling w-full"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                  ])),
                              (_ctx.v$.customCloneControlObject.controlClass.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                    (_ctx.v$.customCloneControlObject.controlClass && _ctx.v$.customCloneControlObject.controlClass.restrictCharacters300.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_128, [
                            _cache[89] || (_cache[89] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_129, _toDisplayString(_ctx.customCloneControlObject.Description || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.Description.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.controlTitle
                                        }]),
                                  placeholder: "Description",
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.customCloneControlObject.Description) = $event)),
                                  disabled: !_ctx.customCloneControlObject.controlTitle
                                }, "                                    ", 10, _hoisted_130)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.Description.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                  (_ctx.v$.customCloneControlObject.Description && _ctx.v$.customCloneControlObject.Description.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_132, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_133, [
                            _cache[90] || (_cache[90] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_ctx.customCloneControlObject.controlMaintenanceTask || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.controlMaintenanceTask.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.controlTitle
                                        }]),
                                  placeholder: "Tasks",
                                  disabled: !_ctx.customCloneControlObject.controlTitle,
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.customCloneControlObject.controlMaintenanceTask) = $event)),
                                  onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.v$.customCloneControlObject.controlMaintenanceTask.$touch()))
                                }, "                                    ", 42, _hoisted_135)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlMaintenanceTask,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.controlMaintenanceTask.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                  (_ctx.v$.customCloneControlObject.controlMaintenanceTask && _ctx.v$.customCloneControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_137, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_138, [
                            _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString(_ctx.customCloneControlObject.controlPolicies || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.controlPolicies.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.controlTitle
                                        }]),
                                  placeholder: "Policies",
                                  disabled: !_ctx.customCloneControlObject.controlTitle,
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.customCloneControlObject.controlPolicies) = $event)),
                                  onInput: _cache[45] || (_cache[45] = ($event: any) => (_ctx.v$.customCloneControlObject.controlPolicies.$touch()))
                                }, "                                    ", 42, _hoisted_140)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlPolicies,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.controlPolicies.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                  (_ctx.v$.customCloneControlObject.controlPolicies && _ctx.v$.customCloneControlObject.controlPolicies.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_143, [
                            _cache[92] || (_cache[92] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_144, _toDisplayString(_ctx.customCloneControlObject.controlGuidance || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.controlGuidance.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.controlTitle
                                        }]),
                                  placeholder: "Guidance",
                                  disabled: !_ctx.customCloneControlObject.controlTitle,
                                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.customCloneControlObject.controlGuidance) = $event)),
                                  onInput: _cache[47] || (_cache[47] = ($event: any) => (_ctx.v$.customCloneControlObject.controlGuidance.$touch()))
                                }, "                                    ", 42, _hoisted_145)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlGuidance,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.controlGuidance.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                  (_ctx.v$.customCloneControlObject.controlGuidance && _ctx.v$.customCloneControlObject.controlGuidance.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_147, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[93] || (_cache[93] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_148, _toDisplayString(_ctx.customCloneControlObject.controlOptionFrameWork || 'N/A'), 1))
                            : (_openBlock(), _createBlock(_component_Select, {
                                key: 1,
                                modelValue: _ctx.customCloneControlObject.controlOptionFrameWork,
                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.customCloneControlObject.controlOptionFrameWork) = $event)),
                                options: _ctx.frameWorksList,
                                onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.getFrameworkControls(_ctx.customCloneControlObject.controlOptionFrameWork))),
                                placeholder: "Please select one",
                                disabled: !_ctx.customCloneControlObject.controlTitle,
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                    'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork === '',
                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork !== ''
                                    }])
                              }, null, 8, ["modelValue", "options", "disabled", "class"]))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[94] || (_cache[94] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(_ctx.customCloneControlObject.frameworkControls || 'N/A'), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.customCloneControlObject.frameworkControls,
                                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.customCloneControlObject.frameworkControls) = $event)),
                                  options: _ctx.frameworkControls,
                                  optionValue: "value",
                                  optionLabel: "label",
                                  disabled: !_ctx.customCloneControlObject.controlOptionFrameWork || !_ctx.customCloneControlObject.controlTitle,
                                  appendTo: "self",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                        'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork !== ''
                                                    }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])
                              ]))
                        ], 2)
                      ])
                    ])
                  ])
                ], 8, _hoisted_97)
              ]),
              (_ctx.clonepopup=true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _cache[95] || (_cache[95] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    (!_ctx.customCloneControlObject._id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.onCancelbtnCustomForCloning('cancel')))
                          }, "Reset", 10, _hoisted_153),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", _ctx.disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.saveCustomControlForCloning(_ctx.customCloneControlObject)))
                          }, "Save", 10, _hoisted_154)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 64))
}